<template>
  <div>
     <el-card >
     <!--修改角色信息 dialog-->
    <el-dialog title="修改角色信息"  :visible.sync="dialogFormVisible" @close="dialogFormVisibleClose">
      <el-form v-model="selectedRole" style="text-align: left" ref="dataForm">
        <el-form-item label="角色名" label-width="120px" prop="username"  >
          <el-input v-model="selectedRole.name" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="角色描述" label-width="120px" prop="name" v-if="selectedRole.name!='putong' && selectedRole.name!='manager'">
          <el-input v-model="selectedRole.nameZh" autocomplete="off"></el-input>
        </el-form-item>
      
        <el-form-item label="角色描述" label-width="120px" prop="name" v-if="selectedRole.name=='putong' || selectedRole.name=='manager'">
          <el-input v-model="selectedRole.nameZh" autocomplete="off" disabled></el-input>
        </el-form-item>
        <!--功能配置先不配置-->
        <!-- <el-form-item label="功能配置" label-width="120px" prop="perms">
          <el-checkbox-group v-model="selectedPermsIds">
            <el-checkbox v-for="(perm,i) in perms" :key="i" :label="perm.id">{{perm.desc}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
        <el-form-item label="菜单配置" label-width="120px" prop="menus">
          <el-tree :data="menus"   :check-strictly="checkStrictly" :props="props" show-checkbox :default-checked-keys="selectedMenusIds" @check="checkeTree" node-key="id" ref="tree"> </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit(selectedRole)">确 定</el-button>
      </div>
    </el-dialog>
    <!--添加角色 dialog-->
    <el-dialog title="添加角色" :visible.sync="adddialogFormVisible"  @close="clear"  width="25%">
       <el-form   ref="roleFormRef"  :model="roleForm" :rules="ruleRoleForms" label-position="left" label-width="0px">
        <el-form-item prop="name">
          <el-input type="text" v-model="roleForm.name"  placeholder="角色名"></el-input>
        </el-form-item>
        <el-form-item prop="nameZh">
          <el-input type="text" v-model="roleForm.nameZh"  placeholder="角色描述"></el-input>
        </el-form-item>
        <el-form-item style="width: 100%">
          <el-button type="primary" style="width: 40%;background: #505458;border: none" v-on:click="createRole">添加</el-button>
        </el-form-item>
        <el-form-item >
          <el-tag>初始权限：无</el-tag>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-row style="margin: 18px 0px 0px 18px ">
        <!-- 面包线导航 -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home?'+ new Date()}">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>角色</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <!--添加角色 按钮-->
    <!-- <el-button class="add-button" type="success" @click="adddialogFormVisible = true" >添加角色</el-button> -->
    <!-- 数据渲染 -->
      <el-table :data="roles" border stripe :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
        <el-table-column label="序号"   type="index" width="80"></el-table-column>
        <el-table-column prop="name" label="角色名" width="200"> </el-table-column>
        <el-table-column prop="nameZh"  label="角色描述" width="200"> </el-table-column>
        <el-table-column label="状态"  width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.name === 'admin' || scope.row.name == 'putong' || scope.row.name == 'manager'">
                  <el-switch v-model="scope.row.enabled"  disabled active-value="0" inactive-value="1"   active-color="#13ce66"  inactive-color="#ff4949"
                      @change="(value) => commitStatusChange(value, scope.row)">
                  </el-switch>
            </span>
            <span v-if="scope.row.name != 'admin' && scope.row.name != 'putong' && scope.row.name != 'manager' ">
                  <el-switch v-model="scope.row.enabled"  active-value="0" inactive-value="1"   active-color="#13ce66"  inactive-color="#ff4949"
                      @change="(value) => commitStatusChange(value, scope.row)">
                  </el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.name === 'admin'">
                <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false" >  
                  <el-button  type="primary" icon="el-icon-edit"  size="small" disabled   @click="editRole(scope.row)">  </el-button>
                </el-tooltip>
            </span>
            <span v-if="scope.row.name !== 'admin'">
                <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false" >  
                  <el-button  type="primary" icon="el-icon-edit"  size="small"  @click="editRole(scope.row)">  </el-button>
                </el-tooltip>
                <span v-if="scope.row.name != 'putong' && scope.row.name != 'manager'">
                <el-tooltip effect="dark" content="删除" placement="top" :enterable="false" >  
                  <el-button type="danger" size="small"   icon="el-icon-delete" @click="deletRole(scope.row)" >  </el-button>
                </el-tooltip>
                </span>
            </span>
          </template>
        </el-table-column>
      </el-table>
       <!-- 分页区间 -->
      <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="pageNum"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'UserRole',
    data () {
        var checkName=(rule,value,cb)=>{
            const  regName=/^[a-zA-Z]*$/
            if(regName.test(value)&&value!=''){
                return cb();
            }
            cb(new Error('请输入字母!'))
        }
        var checknameZh=(rule,value,cb)=>{
            const  regName=/[\u4E00-\u9FA5]/
            if(regName.test(value)){
                return cb();
            }
            cb(new Error('请输入文字!'))
        }
      return {
        dialogFormVisible: false,
        adddialogFormVisible:false,
        ruleRoleForms: {
          name: [{ validator : checkName, trigger: 'blur'},{ min: 2,  max: 8,  message: '长度在 2 到 12 个字符!',   trigger: 'blur' }],
          nameZh: [{ validator : checknameZh, trigger: 'blur'},{ min: 2,  max: 8,  message: '长度在 2 到 12 个字符!',   trigger: 'blur' }]
        },
        roles: [],
        perms: [],
        menus: [],
        pageNum:1,
        total:0,
        checkStrictly:false,
        selectedRole: [],
        selectedPermsIds: [],
        selectedMenusIds: [],
        props: {
          id: 'id',
          label: 'nameZh',
          children: 'children'
        },
         roleForm: {
          name: '',
          nameZh: ''
        },
      }
    },
    mounted () {
      //获取角色
      this.listRoles()
      //获取权限
      //this.listPerms()
      //获取页面菜单
      this.listMenus()
    },
    computed: {
      tableHeight () {
        return window.innerHeight - 320
      }
    },
    methods: {
        // 选中子节点，默认选中父节点
        checkeTree(data){
            let thisNode = this.$refs.tree.getNode(data.id) // 获取当前节点
            
            let keys = this.$refs.tree.getCheckedKeys() // 获取已勾选节点的key值
            if (thisNode.checked) { // 当前节点若被选中
              for (let i = thisNode.level; i > 1; i--) { // 判断是否有父级节点
                if (!thisNode.parent.checked) { // 父级节点未被选中，则将父节点替换成当前节点，往上继续查询，并将此节点key存入keys数组
                    keys.push(thisNode.parent.data.id)
                  }
              }
              //查找所有子节点
              if(thisNode.childNodes != undefined){
                  let childNodes= thisNode.childNodes
                  childNodes.forEach(function(childNode, index) {
                      keys.push(childNode.data.id)
                })
              }
              console.log(keys)
              this.$refs.tree.setCheckedKeys(keys) // 将所有keys数组的节点全选中
            }
            if(!thisNode.checked){
              let temp=[]
              if(thisNode.childNodes != undefined){
                  //获取子节点
                  let childNodes= thisNode.childNodes
                  childNodes.forEach(function(childNode, index) {
                      temp.push(childNode.data.id)
                  })
              }
              if(temp.length>0){
                  temp.forEach(function(item, index) {
                    keys.forEach(function(key, index) {
                        if(item == key){
                          keys.splice(index,1)
                          return true
                        }
                  })
              })
              console.log(temp)
              this.$refs.tree.setCheckedKeys(keys) // 将所有keys数组的节点全选中
              }
            }
        },
        //点击指定页码跳转
        handleCurrentChange(page){
          this.num=page;
          this.listRoles();
        },
        //创建角色
        createRole () {
        this.$refs.roleFormRef.validate(  valid => {
          if(!valid){  return;}
          let params= {
              name: this.roleForm.name,
              nameZh: this.roleForm.nameZh
          }
          if(this.roleForm.name==undefined||this.roleForm.name==''){
            return this.$message.error("角色名为空!");
          }
          if(this.roleForm.nameZh==undefined||this.roleForm.nameZh==''){
            return this.$message.error("角色描述为空!");
          }
          this.$http.post('/role/addRole',JSON.stringify(params))
          .then(response => {
                      if (response.data.code === 200) {
                          this.$message.success("添加成功!");
                          this.adddialogFormVisible = false
                          this.clear()
                          this.listRoles();
                      }else{
                          return this.$message.error(response.data.message);
                      }
            }).catch(failResponse => {
          })
        })
      },
      //清空对象
      clear () {
        this.$refs.roleFormRef.resetFields();
        this.roleForm = {
          name: '',
          nameZh: ''
        }
      },
      //获取角色列表
      listRoles () {
        var _this = this
        this.$http.get('/role/allRoles',{params:{pageNum:this.pageNum}}).then(resp => {
          if (resp && resp.status === 200) {
            _this.roles = resp.data.result.data
            _this.total=resp.data.result.total
            console.log(_this.total)
          }
        })
      },
      //获取权限
      listPerms () {
        var _this = this
        this.$http.get('/admin/role/perm').then(resp => {
          if (resp && resp.data.code === 200) {
            _this.perms = resp.data.data
          }
        })
      },
      //获取菜单
      listMenus () {
        var _this = this
        this.$http.get('/menu/allMenus').then(resp => {
          if (resp && resp.data.code === 200) {
            _this.menus = resp.data.result
          }
        })
      },
      commitStatusChange (value, role) {
            this.$http.get('/role/updateRoleStatus', {params:{
              enabled: value,
              id: role.id
            }}).then(resp => {
              if (resp && resp.data.code === 200) {
                if (value=="0") {
                  this.$message('角色 [' + role.nameZh + '] 已启用')
                } else {
                  this.$message('角色 [' + role.nameZh + '] 已禁用')
                }
              }else{
                this.$message.error(resp.data.message);
                if(role.enabled=="1"){
                  role.enabled="0"
                }else{
                   role.enabled="1"
                }
              }
            })
         
      },
    //编辑角色
    editRole (role) {
      this.checkStrictly=true
      this.dialogFormVisible = true
      this.selectedRole = role
      let menuIds = []
      let _menus=role.menus;
      if(_menus != null &&  _menus.length>0 && _menus[0] !=null){
        for (let i = 0; i < _menus.length; i++) {
            if(_menus[i].children!=undefined && _menus[i].children !=null){
              for (let j = 0; j < _menus[i].children.length; j++) {
                    menuIds.push(_menus[i].children[j].id)
              }
              menuIds.push(_menus[i].id)
            }
        }
      }
      this.selectedMenusIds = menuIds
      // 判断树是否已经加载，第一次打开对话框前树不存在，会报错。所以需要设置 default-checked
      if (this.$refs.tree) {
        console.log(menuIds);
        this.$refs.tree.setCheckedKeys(menuIds)
        //this.checkStrictly=false
      }
    },
    deletRole(role){
      this.$confirm('确认删除？', '提示', {confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
                      let _id= role.id;
                      console.log(_id)
                      this.$http.get('/role/deleteRole',{params:{ id : _id}} )
                      .then(resp => {
                        if (resp && resp.data.code === 200) {
                            this.listRoles ();
                            this.$message('删除成功')
                        }
                      })
                    }).catch(() => {
                      this.$message({
                        message: '已取消'
                      })
                    })
    },
    dialogFormVisibleClose(){
       //获取角色
      this.listRoles()
      this.dialogFormVisible = false;
      this.selectedMenusIds=[];
      this.selectedRole=[];
      //this.checkStrictly=true
      this.$refs.tree.setCheckedKeys([])
    },
    onSubmit (role) {
          let parentArr = this.$refs.tree.getHalfCheckedKeys(); 
          let childArr =this.$refs.tree.getCheckedKeys()
          childArr=childArr.concat(parentArr);
          this.$http.post('/role/editRole', {
            id: role.id,
            name: role.name,
            nameZh: role.nameZh,
            enabled: role.enabled,
            menusIds: childArr
          }).then(resp => {
            if ( resp.data.code === 200) {
              this.$message.success("修改成功!");
              this.dialogFormVisible = false
              this.listRoles()
            }else{
              this.$message.error(resp.data.message);
            }
          })
        
      }
    }
  }
</script>

<style scoped>
  .add-button {
    float: left;
    margin: 18px 0 18px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Role.vue